import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapePin extends Shape {
    width = 200;
    height = 200;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 7) / 8 - 2 * horizontalPadding;
        const allowedHeight = height - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + (width * 7) / 8 / 2 - textPart.width / 2;
        textPart.startY = y + this.getTextLineHeight(textPart) + height / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, w: number, h: number) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m2 2h20v20h-20z" fill="${fill}" stroke="${stroke}" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
